import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-concessionaria-loja-de-veiculos")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-concessionaria-loja-de-veiculos"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-concessionaria-loja-de-veiculos"]!.metaDescription,
    path: "/agente-ia-concessionaria-loja-de-veiculos",
  }),
  component: () => <SegmentRoute slug="agente-ia-concessionaria-loja-de-veiculos" />,
});
